import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityDireccionesGeograficaIDEExactaState
} from './entity-direcciones-geografica-ide.state';
import {
  entityDireccionGeograficaExactaIDELoadFailure,
  entityDireccionGeograficaExactaIDELoadRequest,
  entityDireccionGeograficaExactaIDELoadSuccess
} from './entity-direcciones-geografica-ide.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityDireccionGeograficaExactaIDELoadRequest, (state, {d,mapa}) => ({
    ...state,
    mapa: mapa,
    isLoading: true,
    error: null
  })),
  on(entityDireccionGeograficaExactaIDELoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityDireccionGeograficaExactaIDELoadSuccess, (state, { items }) =>
    ({
      ...state,
      direccionGeograficaIDEExacta: items,
      isLoading: false,
      error: null
    })
  ),
);

export function direccionesGeograficaIDEExactaReducer(
  state: EntityDireccionesGeograficaIDEExactaState | undefined,
  action: Action
) {
  return reducer(state, action);
}
